import * as manager from '@/api/managers'
import {
  SET_MANAGER,
  SET_LIST_MANAGER
} from '@/store/mutation-types'

const fetchManagers = ({commit, dispatch}, params) => {
  dispatch('toggleLoadding', true, {root: true})
  manager.getManagers(params).then(response => {
    if (response.status === 1) {
      dispatch('toggleLoadding', false, {root: true})
      commit(SET_LIST_MANAGER, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const setManagers = ({commit}, data) => {
  commit(SET_LIST_MANAGER, data)
}

const setManager = ({commit}, data) => {
  commit(SET_MANAGER, data)
}

export default{
  fetchManagers,
  setManagers,
  setManager
}



// WEBPACK FOOTER //
// ./src/components/manager/store/actions.js